import React, { useState } from "react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./ui/tooltip";
import { Info } from "lucide-react";

const InputBox = ({
  usedFor,
  boxLabel,
  value,
  onChange,
  color = "bg-white",
  mustFill = false,
  description = "",
  className = "",
  validationError = false,
  type = "text",
  children,
  ...props
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [hasInteracted, setHasInteracted] = useState(false);

  const handleBlur = () => {
    setIsFocused(false);
    setHasInteracted(true);
  };

  const showError = hasInteracted && validationError;

  return (
    <div className={`relative ${className}`}>
      <input
        type={type}
        id={usedFor}
        value={value}
        onChange={onChange}
        onFocus={() => setIsFocused(true)}
        onBlur={handleBlur}
        className={`w-full p-3 border ${
          showError
            ? "border-red-500 focus:border-red-500"
            : isFocused
            ? "border-gray-600"
            : "border-gray-400"
        } rounded-lg outline-none ${color} transition-colors`}
        {...props}
      />
      <label
        htmlFor={usedFor}
        className={`absolute -top-2 left-2 px-1 text-sm ${
          showError ? "text-red-500" : "text-gray-500"
        } ${color} transition-colors`}
      >
        {boxLabel}
        {!mustFill && (
          <span className="text-gray-400 ml-1 text-xs">(optional)</span>
        )}
      </label>
      {children}
      {description && (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Info className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400 hover:text-gray-600 cursor-help" />
            </TooltipTrigger>
            <TooltipContent>
              <p>{description}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      )}
    </div>
  );
};

export default InputBox;
